    

    jQuery(document).ready(function (){
        jQuery(".PwzrGrid-root [role=button]").on("click", function(){
            if(location.href.indexOf("variant") > 0)
                history.pushState(null, "", location.href);      
        });
    });

 
	window.onpopstate = function() {
		window.location.reload();
	}	
